var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75749 11.7664L6.97662 11.1417L5.72723 12.7034L6.5081 13.3281L7.75749 11.7664ZM11.042 15.6746L10.4173 16.4555C10.6391 16.6329 10.9258 16.7076 11.2059 16.6611C11.4861 16.6145 11.7332 16.4511 11.8857 16.2115L11.042 15.6746ZM17.3586 7.61122L17.8954 6.76756L16.2081 5.69381L15.6712 6.53747L17.3586 7.61122ZM6.5081 13.3281L10.4173 16.4555L11.6667 14.8937L7.75749 11.7664L6.5081 13.3281ZM11.8857 16.2115L17.3586 7.61122L15.6712 6.53747L10.1983 15.1377L11.8857 16.2115Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.995bb85a.svg";
export { ForwardRef as ReactComponent };